import React, { useState } from "react";
import { recipientimport } from "../../../services/CommonService";
import { toast } from "react-toastify";

const Recipientsimport = ({ setIsEffect }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file && file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      toast.error("Only CSV files are allowed!");
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      // alert("Please select a file first!");
      toast.warning("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      await recipientimport(formData);
      // console.log("File uploaded successfully");
      toast.success("File uploaded successfully");
      setShowModal(false); //

      setIsEffect(prev => !prev);
    } catch (error) {
      console.error("Error uploading file:", error.response ? error.response.data : error.message);
      // alert("File upload failed");
      toast.error('File already uploaded');
    }
  };

  return (
    <div>
      <button
        className="btn import-btn"
        onClick={() => setShowModal(true)}
        title="Import recipients from CSV file">
        <i className="bi bi-download me-2"></i>
        Import
      </button>

      {showModal && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Import Collaborators</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}>
                  <i className="bi bi-x-circle"></i>
                </button>
              </div>
              <div className="modal-body">
                <div>
                  <label className="form-label mb-2">Select CSV File</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={handleFileChange}
                    accept=".csv"
                  />
                  <div className="form-text">
                    Please ensure your CSV file contains the required columns: first_name, last_name, email, mobile, company_name
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleUpload}>Upload</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && <div className="modal-backdrop show" onClick={() => setShowModal(false)}></div>}
    </div>
  );
};

export default Recipientsimport;
